import { Component, ViewChild } from '@angular/core';
import {
  FilterableSettings,
  DataBindingDirective,
  GridDataResult,
  PageChangeEvent,
  DataStateChangeEvent,
  GridComponent,
} from '@progress/kendo-angular-grid';
import { DecimalPipe, formatDate } from '@angular/common';
import { SVGIcon, filePdfIcon, fileExcelIcon } from '@progress/kendo-svg-icons';
import { process, State } from '@progress/kendo-data-query';
import { billsData } from './bills-data';
import Swal from 'sweetalert2';
import { FormBuilder, FormGroup, FormArray } from '@angular/forms';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import {
  SelectableSettings,
  SelectableMode,
} from '@progress/kendo-angular-grid';
import { SharedService } from '../../../shared/shared.service';

import {
  orderBy,
  SortDescriptor,
  filterBy,
  CompositeFilterDescriptor,
  FilterDescriptor,
} from '@progress/kendo-data-query';
import { Store, select } from '@ngrx/store';
import { Router } from '@angular/router';
import { LoaderService } from '../../../core/services/loader.service';
import {
  getAdhoctExportResponse,
  getAdhoctResponse,
  getBillsExportResponse,
  getBillsResponse,
  getManualExportResponse,
  getManualResponse,
} from '../../../store/Bills/bills-selector';
import {
  getAdhoclist,
  getAdhoclistExport,
  getBillsListExport,
  getBillslist,
  getManuallist,
  getManuallistExport,
  resetbillsAdhocState,
  resetbillsManualState,
  resetbillsState,
} from '../../../store/Bills/bills.action';
import { PdfexportService } from '../../../core/services/pdfexport.service';
import { table_pageSize } from '../../../shared/constants/templatesNames';
import { TooltipDirective } from '@progress/kendo-angular-tooltip';
import { SweetAlertIcon } from '../../../shared/constants/enum';
import { Subscription } from 'rxjs';
import { CdkStepper } from '@angular/cdk/stepper';
import { BillsService } from '../../../core/services/bills.service';
import _ from 'lodash';
import { NotificationService } from '../../../shared/notification.service';

@Component({
  selector: 'app-rp-bills',
  templateUrl: './rp-bills.component.html',
  styleUrl: './rp-bills.component.scss',
  standalone: false,
})
export class RpBillsComponent {
  orderByQuery: string = '';

  ordeyrByManualQuery: string = '';
  orderByAdhocQuery: string = '';

  adhocqueryString: string = '';
  manualqueryString: string = '';
  billqueryString: string = '';

  isbillmanualGeneratefields: boolean = true;
  isbillAdhocGeneratefields: boolean = true;

  billsearchedValue = '';
  @ViewChild('cdkStepper') stepper: CdkStepper | undefined;
  selectedIndex = 2;
  public filterMode: FilterableSettings = 'row';
  public filePdfIcon: SVGIcon = filePdfIcon;
  public fileExcelIcon: SVGIcon = fileExcelIcon;
  public mySelection: string[] = [];
  public selectableSettings: SelectableSettings;
  public selectableSettingsManual!: SelectableSettings;
  public selectableSettingsAdhoc!: SelectableSettings;
  public checkboxOnly = true;
  public drag = false;
  public mode: SelectableMode = 'multiple';

  @ViewChild('pdfGrid') public hiddenGrid: GridComponent | undefined;
  @ViewChild('BillspdfGrid') public BillspdfGrid: GridComponent | undefined;
  // /
  @ViewChild('manualpdfGrid') public manualpdfGrid: GridComponent | undefined;
  @ViewChild(DataBindingDirective) dataBinding!: DataBindingDirective;

  public pageSize = 10;
  public manualpageSize = 10;
  public adhocpageSize = 10;
  public skip = 0;
  currentPage: number = 1;
  public billstgridData: GridDataResult = { data: [], total: 0 };
  public manualBilsgridData: GridDataResult = { data: [], total: 0 };
  public adhocBillsgridData: GridDataResult = { data: [], total: 0 };
  billsList: any[] = [];
  manualBillsList: any[] = [];
  adhocBillsList: any[] = [];

  public bill: State = {
    skip: 0,
    take: 10,
    filter: {
      logic: 'and',
      filters: [],
    },
  };
  public manualbill: State = {
    skip: 0,
    take: 10,
    filter: {
      logic: 'and',
      filters: [],
    },
  };
  public adhocbill: State = {
    skip: 0,
    take: 10,
    filter: {
      logic: 'and',
      filters: [],
    },
  };
  @ViewChild(TooltipDirective) public tooltipDir: TooltipDirective | undefined;
  billstotalUserCount: number = 0;
  adhocbillstotalUserCount: number = 0;
  manualBillstotalUserCount: number = 0;
  billGenType?: string;

  billscurrentPage: number = 1;
  maulabillscurrentPage: number = 1;
  adhocbillscurrentPage: number = 1;
  currentUserData: any;
  projectId: any;
  userId: any;

  public sort: SortDescriptor[] = [];
  public filter: CompositeFilterDescriptor = { logic: 'and', filters: [] };

  public buttonCount = 5;
  public info = true;
  public type: 'numeric' | 'input' = 'numeric';
  //public billpageSizes = true;
  public billpreviousNext = true;
  public billpageSizes = table_pageSize.pageSizes;

  //public manulaBillspageSizes = true;
  public manulaBillspageSizes = table_pageSize.pageSizes;
  public manulaBillspreviousNext = true;
  public adhocbillpageSizes = table_pageSize.pageSizes;
  //public adhocbillpageSizes = true;
  public adhocbillpreviousNext = true;

  public gridData: unknown[] = billsData;
  public gridView!: unknown[];

  manualsarchedValue = '';
  adhocSearchedValue = '';
  billsFilterData: any;
  breadCrumbItems: Array<{}> | undefined;
  public gridDataAdhoc: unknown[] = billsData;

  constructor(
    private modalService: BsModalService,
    private router: Router,
    private notificationService: NotificationService,
    private store: Store,
    private loaderService: LoaderService,
    private sharedService: SharedService,
    private PdfexportService: PdfexportService,
    private billsService: BillsService
  ) {
    this.breadCrumbItems = [{ label: 'Bills' }];
    const currentUserString = localStorage.getItem('currentUser');
    this.currentUserData = JSON.parse(currentUserString ?? '');
    if (this.currentUserData.project !== null) {
      this.projectId = this.currentUserData.project.id;
    }
    if (this.currentUserData.currentUserRoleDetails !== null) {
      this.userId = this.currentUserData.currentUserRoleDetails.userId;
    }

    if (history.state.request != undefined && history.state.request !== null) {
      this.billsFilterData = history.state.request;
      console.log(this.billsFilterData)
    }

    this.selectableSettings = {
      checkboxOnly: this.checkboxOnly,
      mode: this.mode,
      drag: this.drag,
    };
    this.selectableSettingsManual = {
      checkboxOnly: this.checkboxOnly,
      mode: this.mode,
      drag: this.drag,
    };
    this.selectableSettingsAdhoc = {
      checkboxOnly: this.checkboxOnly,
      mode: this.mode,
      drag: this.drag,
    };
   // this.getBillsStoreInfo();
  }
  ngAfterViewInit(): void {
    //    console.log('ngAfterViewInit');
    const savedStepIndex = localStorage.getItem('selectedTabIndex');
    if (savedStepIndex !== null && this.stepper) {
      this.stepper.selectedIndex = +savedStepIndex; // Convert string to number
      localStorage.removeItem('selectedTabIndex'); // Optionally clear it after use
    }
  }

  isFilter: any;
  ngOnInit(): void {
    console.log(this.isFilter);
    this.loaderService.setLoading(true);
    /*  this.isFilter =
       localStorage.getItem('filter') !== null
         ? localStorage.getItem('filter')
         : false; */
    this.gridView = this.gridData;
    if (this.billsFilterData) {
      console.log('Applying initial filters from navigation state.');
      this.initalFilers();
    } else {
      console.log(this.isFilter);
      if (this.isFilter && this.isFilter == 'true') {
        this.previouesfilter();
      } else {
        console.log('No filters applied, loading default data.');
        // this.tabChange({ selectedIndex: 0 });
        this.getAdhoclist();
        this.getBillsList();
        this.getMaunualList();
      }
    }
  }

  initalFilers() {
    const startDate = new Date(this.billsFilterData?.datarange?.startDate);
    let endDate = new Date(this.billsFilterData?.datarange?.endDate);
    const formattedStartDate = `${startDate.getUTCFullYear()}-${(
      startDate.getUTCMonth() + 1
    )
      .toString()
      .padStart(2, '0')}-${startDate
        .getUTCDate()
        .toString()
        .padStart(2, '0')}T00:00:00.000Z`;
    const formattedEndDate = `${endDate.getUTCFullYear()}-${(
      endDate.getUTCMonth() + 1
    )
      .toString()
      .padStart(2, '0')}-${endDate
        .getUTCDate()
        .toString()
        .padStart(2, '0')}T23:59:59.999Z`;

    switch (this.billsFilterData?.billStatus) {
      case 'Paid Bills':
        this.isbillmanualGeneratefields = false;
        this.isbillAdhocGeneratefields = false;

        this.billqueryString = `$filter=paymentStatus eq 'Paid' and (billGeneratedDate ge ${formattedStartDate} and billGeneratedDate le ${formattedEndDate})`;
        this.adhocqueryString = `$filter=paymentStatus eq 'Paid' and (billGeneratedDate ge ${formattedStartDate} and billGeneratedDate le ${formattedEndDate})`;
        this.manualqueryString = `$filter=paymentStatus eq 'Paid' and (billGeneratedDate ge ${formattedStartDate} and billGeneratedDate le ${formattedEndDate})`;

        this.bill = {
          skip: 0,
          take: 10,
          filter: {
            filters: [
              {
                filters: [
                  {
                    field: 'paymentStatus',
                    operator: 'contains',
                    value: 'Paid',
                  },
                ],
                logic: 'and',
              },
              {
                filters: [
                  {
                    field: 'billGeneratedDate',
                    operator: 'gte',
                    value: new Date(startDate),
                  },
                  {
                    field: 'billGeneratedDate',
                    operator: 'lte',
                    value: new Date(endDate),
                  },
                ],
                logic: 'and',
              },
            ],
            logic: 'and',
          },
        };
        this.adhocbill = {
          skip: 0,
          take: 10,
          filter: {
            filters: [
              {
                filters: [
                  {
                    field: 'paymentStatus',
                    operator: 'contains',
                    value: 'Paid',
                  },
                ],
                logic: 'and',
              },
              {
                filters: [
                  {
                    field: 'billGeneratedDate',
                    operator: 'gte',
                    value: new Date(startDate),
                  },
                  {
                    field: 'billGeneratedDate',
                    operator: 'lte',
                    value: new Date(endDate),
                  },
                ],
                logic: 'and',
              },
            ],
            logic: 'and',
          },
        };

        this.manualbill = {
          skip: 0,
          take: 10,
          filter: {
            filters: [
              {
                filters: [
                  {
                    field: 'paymentStatus',
                    operator: 'contains',
                    value: 'Paid',
                  },
                ],
                logic: 'and',
              },
              {
                filters: [
                  {
                    field: 'billGeneratedDate',
                    operator: 'gte',
                    value: new Date(startDate),
                  },
                  {
                    field: 'billGeneratedDate',
                    operator: 'lte',
                    value: new Date(endDate),
                  },
                ],
                logic: 'and',
              },
            ],
            logic: 'and',
          },
        };
        break;
      case 'Total Bills':
        this.isbillmanualGeneratefields = false;
        this.isbillAdhocGeneratefields = false;
        this.billqueryString = `$filter=(billGeneratedDate ge ${formattedStartDate} and billGeneratedDate le ${formattedEndDate})`;
        this.adhocqueryString = `$filter=(billGeneratedDate ge ${formattedStartDate} and billGeneratedDate le ${formattedEndDate})`;
        this.manualqueryString = `$filter=(billGeneratedDate ge ${formattedStartDate} and billGeneratedDate le ${formattedEndDate})`;

        // this.billqueryString = `$filter=contains(paymentStatus,'Paid') and (billGeneratedDate ge ${startDate.toISOString()} and billGeneratedDate le ${endDate.toISOString()})`;
        this.bill = {
          skip: 0,
          take: 10,
          filter: {
            filters: [
              {
                filters: [
                  {
                    field: 'billGeneratedDate',
                    operator: 'gte',
                    value: new Date(startDate),
                  },
                  {
                    field: 'billGeneratedDate',
                    operator: 'lte',
                    value: new Date(endDate),
                  },
                ],
                logic: 'and',
              },
            ],
            logic: 'and',
          },
        };
        this.adhocbill = {
          skip: 0,
          take: 10,
          filter: {
            filters: [
              {
                filters: [
                  {
                    field: 'billGeneratedDate',
                    operator: 'gte',
                    value: new Date(startDate),
                  },
                  {
                    field: 'billGeneratedDate',
                    operator: 'lte',
                    value: new Date(endDate),
                  },
                ],
                logic: 'and',
              },
            ],
            logic: 'and',
          },
        };
        this.manualbill = {
          skip: 0,
          take: 10,
          filter: {
            filters: [
              {
                filters: [
                  {
                    field: 'billGeneratedDate',
                    operator: 'gte',
                    value: new Date(startDate),
                  },
                  {
                    field: 'billGeneratedDate',
                    operator: 'lte',
                    value: new Date(endDate),
                  },
                ],
                logic: 'and',
              },
            ],
            logic: 'and',
          },
        };

        break;
      default:
        this.isbillmanualGeneratefields = false;
        this.isbillAdhocGeneratefields = false;
        this.billqueryString = `$filter=paymentStatus eq 'Unpaid' and (billGeneratedDate ge ${formattedStartDate} and billGeneratedDate le ${formattedEndDate})`;
        this.adhocqueryString = `$filter=paymentStatus eq 'Unpaid' and (billGeneratedDate ge ${formattedStartDate} and billGeneratedDate le ${formattedEndDate})`;
        this.manualqueryString = `$filter=paymentStatus eq 'Unpaid' and (billGeneratedDate ge ${formattedStartDate} and billGeneratedDate le ${formattedEndDate})`;
        this.bill = {
          skip: 0,
          take: 10,
          filter: {
            filters: [
              {
                filters: [
                  {
                    field: 'paymentStatus',
                    operator: 'contains',
                    value: 'Unpaid',
                  },
                ],
                logic: 'and',
              },
              {
                filters: [
                  {
                    field: 'billGeneratedDate',
                    operator: 'gte',
                    value: new Date(startDate),
                  },
                  {
                    field: 'billGeneratedDate',
                    operator: 'lte',
                    value: new Date(endDate),
                  },
                ],
                logic: 'and',
              },
            ],
            logic: 'and',
          },
        };
        this.manualbill = {
          skip: 0,
          take: 10,
          filter: {
            filters: [
              {
                filters: [
                  {
                    field: 'paymentStatus',
                    operator: 'contains',
                    value: 'Unpaid',
                  },
                ],
                logic: 'and',
              },
              {
                filters: [
                  {
                    field: 'billGeneratedDate',
                    operator: 'gte',
                    value: new Date(startDate),
                  },
                  {
                    field: 'billGeneratedDate',
                    operator: 'lte',
                    value: new Date(endDate),
                  },
                ],
                logic: 'and',
              },
            ],
            logic: 'and',
          },
        };
        this.adhocbill = {
          skip: 0,
          take: 10,
          filter: {
            filters: [
              {
                filters: [
                  {
                    field: 'paymentStatus',
                    operator: 'contains',
                    value: 'Unpaid',
                  },
                ],
                logic: 'and',
              },
              {
                filters: [
                  {
                    field: 'billGeneratedDate',
                    operator: 'gte',
                    value: new Date(startDate),
                  },
                  {
                    field: 'billGeneratedDate',
                    operator: 'lte',
                    value: new Date(endDate),
                  },
                ],
                logic: 'and',
              },
            ],
            logic: 'and',
          },
        };
        break;
    }
    // Dispatch actions to fetch the filtered bills
    this.getBillsList();
    this.getMaunualList();
    this.getAdhoclist();
    // this.tabChange({ selectedIndex: 0 });
  }

  dateFormate(date: any) {
    let inputDate: Date = new Date(date);

    // Adjust to the previous day
    inputDate.setUTCDate(inputDate.getUTCDate() - 1);

    // Set time to 23:59:59.000 (end of the previous day)
    inputDate.setUTCHours(23, 59, 59, 0);

    // Convert back to ISO string
    let formattedDate: string = inputDate.toISOString();
    return formattedDate;
    console.log(formattedDate); // Output: "2025-02-03T23:59:59.000Z"
  }

  public billValueChange(ev: string): void {
    const trimmedValue = ev.trim();

    // If user enters only spaces — do nothing (just keep the clear icon visible)
    if (trimmedValue.length === 0 && ev.length > 0) {
      return;
    }

    // If user cleared the box (either manually or by clicking the clear icon)
    if (ev.length === 0) {
      this.billsPageChange({ skip: 0, take: this.pageSize });
      //  this.getUsersData();
    }
    /* if (ev.length == 0) {
      this.getBillsList();
    } */
  }
  private triggerSearchBills(): void {
    const trimmedValue = this.billsearchedValue.trim();

    // If only spaces — do nothing
    if (trimmedValue.length === 0 && this.billsearchedValue.length > 0) {
      return;
    }

    // If empty — load previous data
    if (this.billsearchedValue.length === 0) {
      this.billsPageChange({ skip: 0, take: this.pageSize });
      this.getBillsList();
      return;
    }

    // Otherwise — run search
    this.getBillsList();
  }
  public manualValueChange(ev: string): void {
    const trimmedValue = ev.trim();

    // If user enters only spaces — do nothing (just keep the clear icon visible)
    if (trimmedValue.length === 0 && ev.length > 0) {
      return;
    }

    // If user cleared the box (either manually or by clicking the clear icon)
    if (ev.length === 0) {
      this.manualconsumerPageChange({ skip: 0, take: this.manualpageSize });
      //  this.getUsersData();
    }
    /* if (ev.length == 0) {
      this.getMaunualList();
    } */
  }
  private triggerSearchmanual(): void {
    const trimmedValue = this.manualsarchedValue.trim();

    // If only spaces — do nothing
    if (trimmedValue.length === 0 && this.manualsarchedValue.length > 0) {
      return;
    }

    // If empty — load previous data
    if (this.manualsarchedValue.length === 0) {
      this.manualconsumerPageChange({ skip: 0, take: this.manualpageSize });
      this.getMaunualList();
      return;
    }

    // Otherwise — run search
    this.getMaunualList();
  }
  public adhocValueChange(ev: string): void {
    const trimmedValue = ev.trim();

    // If user enters only spaces — do nothing (just keep the clear icon visible)
    if (trimmedValue.length === 0 && ev.length > 0) {
      return;
    }

    // If user cleared the box (either manually or by clicking the clear icon)
    if (ev.length === 0) {
      this.adhocPageChange({ skip: 0, take: this.adhocpageSize });
      //  this.getUsersData();
    }
    /* if (ev.length == 0) {
      this.getAdhoclist();
    } */
  }
  private triggerSearchAdhoc(): void {
    const trimmedValue = this.adhocSearchedValue.trim();

    // If only spaces — do nothing
    if (trimmedValue.length === 0 && this.adhocSearchedValue.length > 0) {
      return;
    }

    // If empty — load previous data
    if (this.adhocSearchedValue.length === 0) {
      this.adhocPageChange({ skip: 0, take: this.adhocpageSize });
      this.getAdhoclist();
      return;
    }

    // Otherwise — run search
    this.getAdhoclist();
  }
  previouesfilter() {
    console.log('Applying previous filters from shared service.');
    this.filter = this.sharedService.getFilter();
    // this.consumersState.filter = this.filter;

    //  this.queryString = this.sharedService.createQuery(this.consumersState);

    const savedStepIndex = localStorage.getItem('selectedTabIndex');

    // console.log(savedStepIndex)
    switch (savedStepIndex) {
      case '0':
        this.bill.filter = this.filter;
        this.billqueryString = this.sharedService.createQuery(this.bill);
        break;
      case '1':
        this.manualbill.filter = this.filter;
        this.manualqueryString = this.sharedService.createQuery(
          this.manualbill
        );
        break;

      case '2':
        this.adhocbill.filter = this.filter;
        this.adhocqueryString = this.sharedService.createQuery(this.adhocbill);
        break;
    }
    this.getBillsList();
    this.getMaunualList();
    this.getAdhoclist();
  }

  getAdhoclist() {
    /*  this.store.dispatch(
       getAdhoclist({
         projectId: this.projectId,
         pageIndex: this.adhocbillscurrentPage,
         pageSize: this.adhocpageSize,
         searchTerm: this.adhocSearchedValue,
         billType: 'adhoc',
         filter: this.adhocqueryString,
         orderBy: this.orderByQuery,
       })
     ); */

    this.loaderService.setLoading(true);
    this.pageSize,
      this.billsService
        .getAdhocBillsUrl(
          this.projectId,
          this.adhocbillscurrentPage,
          this.adhocpageSize,
          this.adhocSearchedValue,
          'adhoc',
          this.adhocqueryString,
          this.orderByAdhocQuery
        )
        .subscribe({
          next: (res) => {
            if (res && res.statusCode === 200) {
              this.adhocBillsList = [...res.data.items];
              this.billGenType = this.adhocBillsList[0]?.billGenType;
              this.adhocpageSize = res.data.pageSize;
              this.adhocbillstotalUserCount = res.data.totalCount;
              this.loadAdhocBillsGridTable();
              this.loaderService.setLoading(false);
            }
          },
          error: (err) => {
            console.log(err);
            this.loaderService.setLoading(false);

            // Check if backend returned an error.message
            const errorMsg =
              err.error?.message ||
              'Something went wrong. Please try again later.';

            this.sharedService.showMessageDialog(
              errorMsg,
              '',
              SweetAlertIcon.ERROR
            );
          },
        });
  }

  getAdhoclistExport() {
    this.store.dispatch(
      getAdhoclistExport({
        projectId: this.projectId,
        pageIndex: 1,
        pageSize: undefined,
        searchTerm: '',
        billType: 'adhoc',
        filter: '',
        orderBy: '',
        criteria: 'All',
      })
    );
  }

  public showTooltip(e: MouseEvent): void {
    const element = e.target as HTMLElement;

    // Check if the element is a table cell
    if (element.nodeName === 'TD') {
      const cellValue = element.innerText.trim();

      // Only show the tooltip if the cell is not empty, null, or ''
      if (cellValue && !element.closest('.no-tooltip')) {
        this.tooltipDir?.toggle(element);
      } else {
        this.tooltipDir?.hide();
      }
    } else if (element.classList.contains('k-column-title')) {
      this.tooltipDir?.toggle(element);
    } else {
      this.tooltipDir?.hide();
    }
  }

  getBillsListExport() {
    this.store.dispatch(
      getBillsListExport({
        projectId: this.projectId,
        pageIndex: 1,
        pageSize: undefined,
        searchTerm: '',
        billType: 'bills',
        filter: '',
        orderBy: '',
        criteria: 'All',
      })
    );
  }
  getBillsList() {
    this.loaderService.setLoading(true);
    this.pageSize,
      this.billsService
        .getBillsUrl(
          this.billscurrentPage,
          this.pageSize,
          this.billsearchedValue,
          this.projectId,
          'bills',
          this.billqueryString,
          this.orderByQuery
        )
        .subscribe({
          next: (res) => {
            if (res && res.statusCode === 200) {
              console.log(res);
              this.billsList = [...res.data.items];
              this.pageSize = res.data.pageSize;
              this.billstotalUserCount = res.data.totalCount;
              this.loadBillsGridTable();
              this.loaderService.setLoading(false);
            }
          },
          error: (err) => {
            console.log(err);
            this.loaderService.setLoading(false);

            // Check if backend returned an error.message
            const errorMsg =
              err.error?.message ||
              'Something went wrong. Please try again later.';

            this.sharedService.showMessageDialog(
              errorMsg,
              '',
              SweetAlertIcon.ERROR
            );
          },
        });

    /* this.store.dispatch(
      getBillslist({
        projectId: this.projectId,
        pageIndex: this.billscurrentPage,
        pageSize: this.pageSize,
        searchTerm: this.billsearchedValue,
        billType: 'bills',
        filter: this.billqueryString,
        orderBy: this.orderByQuery,
      })
    ); */
  }
  getMaunualListExport() {
    this.store.dispatch(
      getManuallistExport({
        projectId: this.projectId,
        pageIndex: 1,
        pageSize: undefined,
        searchTerm: '',
        billType: 'manual',
        filter: '',
        orderBy: '',
        criteria: 'All',
      })
    );
  }
  getMaunualList() {
    this.loaderService.setLoading(true);
    this.pageSize,
      this.billsService
        .getManualUrl(
          this.maulabillscurrentPage,
          this.manualpageSize,
          this.manualsarchedValue,
          this.projectId,
          'manual',
          this.manualqueryString,
          this.ordeyrByManualQuery
        )
        .subscribe({
          next: (res) => {
            if (res && res.statusCode === 200) {
              this.manualBillsList = [...res.data.items];
              this.billGenType = this.manualBillsList[0]?.billGenType;
              this.manualpageSize = res.data.pageSize;
              this.manualBillstotalUserCount = res.data.totalCount;
              this.loadManualBillsGridTable();
              this.loaderService.setLoading(false);
            }
          },
          error: (err) => {
            console.log(err);
            this.loaderService.setLoading(false);

            // Check if backend returned an error.message
            const errorMsg =
              err.error?.message ||
              'Something went wrong. Please try again later.';

            this.sharedService.showMessageDialog(
              errorMsg,
              '',
              SweetAlertIcon.ERROR
            );
          },
        });
    /*  this.store.dispatch(
       getManuallist({
         projectId: this.projectId,
         pageIndex: this.maulabillscurrentPage,
         pageSize: this.manualpageSize,
         searchTerm: this.manualsarchedValue,
         billType: 'manual',
         filter: this.manualqueryString,
         orderBy: this.orderByQuery,
       })
     ); */
  }

  selectedtabIndex: number = 0;
  tabChange(event: any): void {
    this.loaderService.setLoading(true);
    console.log(event.selectedIndex);
    this.selectedtabIndex = event.selectedIndex;
    // console.log(this.selectedtabIndex);
    this.bill = {
      skip: 0,
      take: 10,
      filter: {
        logic: 'and',
        filters: [],
      },
    };

    this.billqueryString = '';
    this.orderByQuery = '';
    this.manualbill = {
      skip: 0,
      take: 10,
      filter: {
        logic: 'and',
        filters: [],
      },
    };
    this.manualqueryString = '';
    this.ordeyrByManualQuery = '';
    this.adhocbill = {
      skip: 0,
      take: 10,
      filter: {
        logic: 'and',
        filters: [],
      },
    };
    this.adhocqueryString = '';
    this.orderByAdhocQuery = '';



    this.customDateFiltersQueryEq = [];
    this.customDateFiltersQueryNEQ = [];
    this.customFilterState = {
      skip: 0,
      take: 10,
      filter: {
        logic: 'and',
        filters: [],
      },
    };
    this.customManualFilterState = {
      skip: 0,
      take: 10,
      filter: {
        logic: 'and',
        filters: [],
      },
    };

    this.customManualDateFiltersQueryEq = [];
    this.customManualDateFiltersQueryNEQ = [];

    this.customAdhocFilterState = {
      skip: 0,
      take: 10,
      filter: {
        logic: 'and',
        filters: [],
      },
    };
    this.customAdhocDateFiltersQueryEq = [];
    this.customAdhocDateFiltersQueryNEQ = [];

    this.store.dispatch(resetbillsState());

    switch (event.selectedIndex) {
      case 0: // No need for quotes for numeric values
        // Code for selected index 0
        // Dispatch the action to get the bills list
        this.getBillsList();

        break;
      case 1:
        // Code for selected index 1
        this.getMaunualList();
        break;
      default:
        // Code for any other selected index
        this.getAdhoclist();
        break;
    }
  }

  exportAllAdhoc() {
   // this.store.dispatch(resetbillsAdhocState());
   // this.getAdhoclistExport();
    this.loaderService.setLoading(true)
    this.billsService.getAdhocBillsUrl(this.projectId,
       1,
       undefined,
       '',
       'adhoc',
       '',
       '',
      ).subscribe({
        next: (res) =>{
          if (res) {
            if (res) {
              this.adhocExport = [];
              if (res.data.items.length > 0) {
                this.loaderService.setLoading(false)
                this.adhocExport = [...res.data.items];
                const transformedData = this.adhocExport.map((item: any) => ({
                  'Bill No': item.billNo,
                  'Residential Unit': item.residentialUnit,
                  'Consumer Name': item.consumerName,
                  Utility: item.utility,
                  'MAC Address': item.macAddress,
                  'Device Sr No': item.devicesSrNo,
                  'Bill Amount': item.billAmount,
                  Reason: item.reason,
                  'Mode of Payment': item.modeOfPayment,
                  'Payment Date':
                    !item?.paidDate || item.paidDate === '0001-01-01T00:00:00'
                      ? '-'
                      : this.sharedService.dateFormateChnage(item.paidDate),

                  'Bill Generated Date': this.sharedService.dateFormateChnage(
                    item.currentBillGeneratedDate
                  ),
                  'Consumption b/w':
                    this.sharedService.dateFormateChnagewithoutTime(
                      item.billGeneratedFromDate
                    ) +
                    ' - ' +
                    this.sharedService.dateFormateChnagewithoutTime(
                      item.billGeneratedToDate
                    ),
                  'Payment Id': item.transactionId,
                  Status: item.paymentStatus,
                  // 'Released Status': item.isReleased == true ? "Released " : " Not Released",
                  // consumerName: item.consumerName,
                }));
                this.PdfexportService.downloadExcel(transformedData, 'Adhoc Bills');
              } else {
                this.loaderService.setLoading(false)
                this.sharedService.showMessageDialog(
                  'No data to display',
                  '',
                  SweetAlertIcon.ERROR
                );
              }
            }
          }
          
        },
        error: (err) => {
          console.log(err);
          this.loaderService.setLoading(false);

          // Check if backend returned an error.message
          const errorMsg =
            err.error?.message ||
            'Something went wrong. Please try again later.';

          this.sharedService.showMessageDialog(
            errorMsg,
            '',
            SweetAlertIcon.ERROR
          );
        },
      })
  }

  public onExport(type: string) {
    if (type === 'Excel') {
      if (this.adhocBillsgridData.data.length > 0) {
        setTimeout(() => {
          this.hiddenGrid?.saveAsExcel();
        }, 1000);
      } else {
        this.sharedService.showMessageDialog(
          'No data to display',
          '',
          SweetAlertIcon.ERROR
        );
      }
    } else if (type === 'Pdf') {
      setTimeout(() => {
        this.hiddenGrid?.saveAsPDF();
      }, 1000);
    }
  }
  exportAllBills() {
    // this.store.dispatch(resetbillsState());
    //  this.getBillsListExport();
    this.loaderService.setLoading(true)
    this.billsService.getBillsUrl(
      1,
      undefined,
      '',
      this.projectId,
      'bills',
      '',
      '',
    ).subscribe({
      next: (res) => {
        if (res) {
          this.billExport = [];
          if (res.data.items.length) {
            this.loaderService.setLoading(false)
            this.billExport = [...res.data.items];
            const transformedData = this.billExport.map((item: any) => ({
              'Bill No': item.billNo,
              'Residential Unit': item.residentialUnit,
              Utility: item.utility,
              Consumer: item.consumerName,
              'MAC Address': item.macAddress,
              'Device Sr No': item.devicesSrNo,
              'Bill Amount': item.billAmount,
              Reason: item.reason,
              'Payment Date':
                !item?.paidDate || item.paidDate === '0001-01-01T00:00:00'
                  ? '-'
                  : this.sharedService.dateFormateChnage(item.paidDate),
              'Bill Generated Date': this.sharedService.dateFormateChnage(
                item.billGeneratedDate
              ),
              'bill Month': item.billMonth,
              'Released Status':
                item.isReleased == true ? 'Released' : 'Not Released',
              // 'Consumption b/w': item.consumptioDate,
              // 'FromToDate': item.FromToDate,
              'Mode of Payment': item.modeOfPayment,
              'Payment Id': item.transactionId,
              'Payment Status': item.paymentStatus,
            }));
            this.PdfexportService.downloadExcel(transformedData, 'Bills');
          } else {
            this.loaderService.setLoading(false)
            this.sharedService.showMessageDialog(
              'No data to display',
              '',
              SweetAlertIcon.ERROR
            );
          }
        }
      },
      error: (err) => {
        console.log(err);
        this.loaderService.setLoading(false);

        // Check if backend returned an error.message
        const errorMsg =
          err.error?.message ||
          'Something went wrong. Please try again later.';

        this.sharedService.showMessageDialog(
          errorMsg,
          '',
          SweetAlertIcon.ERROR
        );
      },
    })



  }
  public onBillsExport(type: string) {
    if (type === 'Excel') {
      if (this.billstgridData.data.length > 0) {
        setTimeout(() => {
          this.BillspdfGrid?.saveAsExcel();
        }, 1000);
      } else {
        this.sharedService.showMessageDialog(
          'No data to display',
          '',
          SweetAlertIcon.ERROR
        );
      }
    } else if (type === 'Pdf') {
      setTimeout(() => {
        this.BillspdfGrid?.saveAsPDF();
      }, 1000);
    }
    /* if (this.adhocbillselectedRowdata.length == 0) {
      this.getBillsListExport();
    } else {
      if (type === 'Excel') {
        setTimeout(() => {
          this.BillspdfGrid?.saveAsExcel();
        }, 1000);
      } else if (type === 'Pdf') {
        setTimeout(() => {
          this.BillspdfGrid?.saveAsPDF();
        }, 1000);
      }
    } */
  }
  exportAllManual() {
    this.loaderService.setLoading(true)
   // this.store.dispatch(resetbillsManualState());
   // this.getMaunualListExport();

    this.billsService.getManualUrl(
      1,
      undefined,
      '',
      this.projectId,
      'manual',
      '',
      '',
    ).subscribe({
      next: (res)=> {
        if (res) {
          this.manualExport = [];
          if (res.data.items.length) {
            this.manualExport = [...res.data.items];
            this.loaderService.setLoading(false)
            const transformedData = this.manualExport.map((item: any) => ({
              'Bill No': item.billNo,
              'Residential Unit': item.residentialUnit,
              Consumer: item.consumerName,
              Utility: item.utility,
              'MAC Address': item.macAddress,
              'Device Sr No': item.devicesSrNo,
              'Bill Amount': item.billAmount,
              Reason: item.reason,
              'Mode of Payment': item.modeOfPayment,
              'Payment Date':
                !item?.paidDate || item.paidDate === '0001-01-01T00:00:00'
                  ? '-'
                  : this.sharedService.dateFormateChnage(item.paidDate),

              'Bill Generated Date': this.sharedService.dateFormateChnage(
                item.currentBillGeneratedDate
              ),
              'Bill Month': item.billMonth,
              'Payment Id': item.transactionId,
              Status: item.paymentStatus,
            }));
            this.PdfexportService.downloadExcel(transformedData, 'Manual Bills');
          } else {
            this.loaderService.setLoading(false)
            this.sharedService.showMessageDialog(
              'No data to display',
              '',
              SweetAlertIcon.ERROR
            );
          }
        }
      },
      error: (err) => {
        console.log(err);
        this.loaderService.setLoading(false);

        // Check if backend returned an error.message
        const errorMsg =
          err.error?.message ||
          'Something went wrong. Please try again later.';

        this.sharedService.showMessageDialog(
          errorMsg,
          '',
          SweetAlertIcon.ERROR
        );
      },
    })

  }
  public onManualExport(type: string) {
    if (type === 'Excel') {
      if (this.manualBilsgridData.data.length > 0) {
        setTimeout(() => {
          this.manualpdfGrid?.saveAsExcel();
        }, 1000);
      } else {
        this.sharedService.showMessageDialog(
          'No data to display',
          '',
          SweetAlertIcon.ERROR
        );
      }
    } else if (type === 'Pdf') {
      setTimeout(() => {
        this.manualpdfGrid?.saveAsPDF();
      }, 1000);
    }
    /*  if (this.manualbillselectedRowdata.length == 0) {
       this.getMaunualListExport();
     } else {
       if (type === 'Excel') {
         setTimeout(() => {
           this.manualpdfGrid?.saveAsExcel();
         }, 1000);
       } else if (type === 'Pdf') {
         setTimeout(() => {
           this.manualpdfGrid?.saveAsPDF();
         }, 1000);
       }
     } */
  }

  private exportSubscriptionAdhoc: Subscription = new Subscription();
  private exportSubscriptionBill: Subscription = new Subscription();
  private exportSubscriptionManual: Subscription = new Subscription();
  adhocExport: any[] = [];
  manualExport: any[] = [];
  billExport: any[] = [];
  getBillsStoreInfo() {
    /*  this.store.dispatch(resetbillsState());
     this.store.dispatch(resetbillsAdhocState());
     this.store.dispatch(resetbillsManualState()); */

    /*   let getBills$ = this.store.pipe(select(getBillsResponse));
      let getManualBills$ = this.store.pipe(select(getManualResponse));
      let getAdhocBills$ = this.store.pipe(select(getAdhoctResponse)); */

   /*  this.exportSubscriptionAdhoc = this.store
      .pipe(select(getAdhoctExportResponse))
      .subscribe({
        next: (res: any) => {
          if (res) {
            if (res) {
              this.adhocExport = [];
              if (res.items.length > 0) {
                this.adhocExport = [...res.items];
                const transformedData = this.adhocExport.map((item: any) => ({
                  'Bill No': item.billNo,
                  'Residential Unit': item.residentialUnit,
                  'Consumer Name': item.consumerName,
                  Utility: item.utility,
                  'MAC Address': item.macAddress,
                  'Device Sr. No': item.devicesSrNo,
                  'Bill Amount': item.billAmount,
                  Reason: item.reason,
                  'Mode of Payment': item.modeOfPayment,
                  'Payment Date':
                    !item?.paidDate || item.paidDate === '0001-01-01T00:00:00'
                      ? '-'
                      : this.sharedService.dateFormateChnage(item.paidDate),

                  'Bill Generated Date': this.sharedService.dateFormateChnage(
                    item.currentBillGeneratedDate
                  ),
                  'Consumption b/w':
                    this.sharedService.dateFormateChnagewithoutTime(
                      item.billGeneratedFromDate
                    ) +
                    ' - ' +
                    this.sharedService.dateFormateChnagewithoutTime(
                      item.billGeneratedToDate
                    ),
                  'Payment Id': item.transactionId,
                  Status: item.paymentStatus,
                  // 'Released Status': item.isReleased == true ? "Released " : " Not Released",
                  // consumerName: item.consumerName,
                }));
                this.PdfexportService.downloadExcel(transformedData, 'Adhoc');
              } else {
                this.sharedService.showMessageDialog(
                  'No data to display',
                  '',
                  SweetAlertIcon.ERROR
                );
              }
            }
          }
        },
      }); */
    /* this.exportSubscriptionManual = this.store
      .pipe(select(getManualExportResponse))
      .subscribe({
        next: (res: any) => {
          if (res) {
            this.manualExport = [];
            if (res.items.length) {
              this.manualExport = [...res.items];
              const transformedData = this.manualExport.map((item: any) => ({
                'Bill No': item.billNo,
                'Residential Unit': item.residentialUnit,
                Consumer: item.consumerName,
                Utility: item.utility,
                'MAC Address': item.macAddress,
                'Device Sr. No': item.devicesSrNo,
                'Bill Amount': item.billAmount,
                Reason: item.reason,
                'Mode of Payment': item.modeOfPayment,
                'Payment Date':
                  !item?.paidDate || item.paidDate === '0001-01-01T00:00:00'
                    ? '-'
                    : this.sharedService.dateFormateChnage(item.paidDate),

                'Bill Generated Date': this.sharedService.dateFormateChnage(
                  item.currentBillGeneratedDate
                ),
                'Bill Month': item.billMonth,
                'Payment Id': item.transactionId,
                Status: item.paymentStatus,
              }));
              this.PdfexportService.downloadExcel(transformedData, 'manual');
            } else {
              this.sharedService.showMessageDialog(
                'No data to display',
                '',
                SweetAlertIcon.ERROR
              );
            }
          }
        },
      }); */

   /*  this.exportSubscriptionBill = this.store
      .pipe(select(getBillsExportResponse))
      .subscribe({
        next: (res: any) => {
          if (res) {
            this.billExport = [];
            if (res.items.length) {
              this.billExport = [...res.items];
              const transformedData = this.billExport.map((item: any) => ({
                'Bill No': item.billNo,
                'Residential Unit': item.residentialUnit,
                Utility: item.utility,
                Consumer: item.consumerName,
                'MAC Address': item.macAddress,
                'Device Sr. No': item.devicesSrNo,
                'Bill Amount': item.billAmount,
                Reason: item.reason,
                'Payment Date':
                  !item?.paidDate || item.paidDate === '0001-01-01T00:00:00'
                    ? '-'
                    : this.sharedService.dateFormateChnage(item.paidDate),
                'Bill Generated Date': this.sharedService.dateFormateChnage(
                  item.billGeneratedDate
                ),
                'bill Month': item.billMonth,
                'Released Status':
                  item.isReleased == true ? 'Released' : 'Not Released',
                // 'Consumption b/w': item.consumptioDate,
                // 'FromToDate': item.FromToDate,
                'Mode of Payment': item.modeOfPayment,
                'Payment Id': item.transactionId,
                'Payment Status': item.paymentStatus,
              }));
              this.PdfexportService.downloadExcel(transformedData, 'Bills');
            } else {
              this.sharedService.showMessageDialog(
                'No data to display',
                '',
                SweetAlertIcon.ERROR
              );
            }
          }
        },
      }); */

    /*   getManualBills$.subscribe((res: any) => {
        this.loaderService.setLoading(false);
        if (res) {
          this.manualBillsList = [...res.items];
          this.billGenType = this.manualBillsList[0]?.billGenType;
          this.manualpageSize = res.pageSize;
          this.manualBillstotalUserCount = res.totalCount;
          this.loadManualBillsGridTable();
        }
        //     console.log('consumerList', res, this.manualBillsList);
      }); */

  }

  ngOnDestroy() {
    this.notificationService.emitNotificationUpdate();
    this.exportSubscriptionAdhoc.unsubscribe();
    this.exportSubscriptionBill.unsubscribe();
    this.exportSubscriptionManual.unsubscribe(); // Or set it to [] if you prefer an empty array
  }
  isReleasebills: boolean = false;
  loadBillsGridTable() {
    const state: any = {
      take: this.pageSize,
      sort: this.sort,
      // filter: this.filter,
      filter: {
        logic: 'and',
        filters: [],
      } as CompositeFilterDescriptor, // Providing a valid filter
    };
    console.log(this.billsList);

    const processedData = process(this.billsList, state);
    console.log(processedData);
    this.billstgridData = {
      data: this.billsList,
      total: this.billstotalUserCount,
    };

    /* this.billstgridData.data.filter((item) => {
      if (item.isReleased == false) {
        this.isReleasebills = true;
      }
    }) */

    this.isReleasebills = !this.billstgridData.data.some(
      (item) => item.isReleased === false
    );

    this.billstgridData.data = this.billstgridData?.data.map((project) => {
      return {
        ...project,
        paidDate:
          project?.paidDate == '0001-01-01T00:00:00'
            ? '-'
            : project?.paidDate != null
              ? this.sharedService.dateFormateChnage(project.paidDate)
              : '-',
        paymentDate:
          project?.paidDate == '0001-01-01T00:00:00'
            ? '-'
            : project?.paidDate != null
              ? this.sharedService.dateFormateChnage(project.paidDate)
              : '-',
        isReleased: project?.isReleased == true ? 'Released ' : 'Not Released',
        billGeneratedDate:
          project?.billGeneratedDate != null
            ? this.sharedService.dateFormateChnage(project.billGeneratedDate)
            : '-',
      };
    });
    //   console.log(this.isReleasebills)
    // this.loaderService.setLoading(false);
  }

  loadManualBillsGridTable() {
    const state: any = {
      take: this.manualpageSize,
      sort: this.sort,
      filter: {
        logic: 'and',
        filters: [],
      } as CompositeFilterDescriptor, // Providing a valid filter
    };
    const processedData = process(this.manualBillsList, state);
    console.log(processedData);
    this.manualBilsgridData = {
      data: this.manualBillsList,
      total: this.manualBillstotalUserCount,
    };

    this.manualBilsgridData.data = this.manualBilsgridData?.data.map(
      (bills) => {
        return {
          ...bills,
          paidDate:
            bills?.paidDate == '0001-01-01T00:00:00'
              ? '-'
              : this.sharedService.dateFormateChnage(bills?.paidDate),
          billGeneratedDate:
            bills?.billGeneratedDate != null
              ? this.sharedService.dateFormateChnage(bills.billGeneratedDate)
              : '-',
        };
      }
    );
    //this.loaderService.setLoading(false);
  }
  loadAdhocBillsGridTable() {
    const state: any = {
      take: this.adhocpageSize,
      sort: this.sort,
      filter: {
        logic: 'and',
        filters: [],
      } as CompositeFilterDescriptor, // Providing a valid filter
    };
    const processedData = process(this.adhocBillsList, state);
    this.adhocBillsgridData = {
      data: this.adhocBillsList,
      total: this.adhocbillstotalUserCount,
    };
    this.adhocBillsgridData.data = this.adhocBillsgridData?.data.map(
      (project) => {
        return {
          ...project,
          paidDate:
            project?.paidDate === '0001-01-01T00:00:00'
              ? '-'
              : project?.paidDate !== null
                ? this.sharedService.dateFormateChnage(project.paidDate)
                : '-',
          paymentDate:
            project?.paidDate === '0001-01-01T00:00:00'
              ? '-'
              : project?.paidDate != null
                ? this.sharedService.dateFormateChnage(project.paidDate)
                : '-',
          billGeneratedDate:
            project?.billGeneratedDate != null
              ? this.sharedService.dateFormateChnage(project.billGeneratedDate)
              : '-',
          consumptioDate:
            project?.billGeneratedFromDate != null &&
              project.billGeneratedToDate != null
              ? `${this.sharedService.dateFormateChnagewithoutTime(
                project.billGeneratedFromDate
              )} - ${this.sharedService.dateFormateChnagewithoutTime(
                project.billGeneratedToDate
              )}`
              : '-',
        };
      }
    );
    //  console.log(this.adhocBillsgridData.data)
    //this.loaderService.setLoading(false);
  }

  public onFilterBill(value: Event): void {
    const inputValue = value;

    this.gridView = process(this.gridData, {
      filter: {
        logic: 'or',
        filters: [
          {
            field: 'ProjectCode',
            operator: 'contains',
            value: inputValue,
          },
          {
            field: 'ProjectName',
            operator: 'contains',
            value: inputValue,
          },
          {
            field: 'Region',
            operator: 'contains',
            value: inputValue,
          },
          {
            field: 'Utility',
            operator: 'contains',
            value: inputValue,
          },
          {
            field: 'ProjectType',
            operator: 'contains',
            value: inputValue,
          },
          {
            field: 'ProjectStatus',
            operator: 'contains',
            value: inputValue,
          },
        ],
      },
    }).data;

    this.dataBinding.skip = 0;
  }

  billselectedRowdata: any = [];
  billsdeselectedRowdata: any = [];
  billsonSelect(event: any) {
    //  console.log(event.selectedRows);
    var selectedval = event.selectedRows;
    var deselectedVal = event.deselectedRows;
    if (selectedval.length > 0) {
      selectedval.forEach((element: any) => {
        this.billselectedRowdata.push(element.dataItem);
        //   console.log(' selected Values : ', this.billselectedRowdata);
      });
    }
    if (deselectedVal.length > 0) {
      deselectedVal.forEach((element: any) => {
        this.billsdeselectedRowdata.push(element.dataItem);
        //    console.log('deselectedRowdata Values : ', this.billsdeselectedRowdata);
      });

      if (this.billsdeselectedRowdata.length > 0) {
        const idsToRemove = new Set(
          this.billsdeselectedRowdata.map((item: { id: any }) => item.id)
        );

        const filteredArray = this.billselectedRowdata.filter(
          (item: { id: unknown }) => !idsToRemove.has(item.id)
        );
        //  console.log('', filteredArray);
        this.billselectedRowdata = filteredArray;
      }
    }
  }
  onSelect(event: any) {
    //  console.log(event);
  }
  manualbillselectedRowdata: any = [];
  manualbillsdeselectedRowdata: any = [];
  manualbillsonSelect(event: any) {
    //    console.log(event.selectedRows);
    var selectedval = event.selectedRows;
    var deselectedVal = event.deselectedRows;
    if (selectedval.length > 0) {
      selectedval.forEach((element: any) => {
        this.manualbillselectedRowdata.push(element.dataItem);
        //   console.log(' selected Values : ', this.manualbillselectedRowdata);
      });
    }
    if (deselectedVal.length > 0) {
      deselectedVal.forEach((element: any) => {
        this.manualbillsdeselectedRowdata.push(element.dataItem);
        /*  console.log(
           'deselectedRowdata Values : ',
           this.manualbillsdeselectedRowdata
         ); */
      });

      if (this.manualbillsdeselectedRowdata.length > 0) {
        const idsToRemove = new Set(
          this.manualbillsdeselectedRowdata.map((item: { id: any }) => item.id)
        );

        const filteredArray = this.manualbillselectedRowdata.filter(
          (item: { id: unknown }) => !idsToRemove.has(item.id)
        );
        // console.log('', filteredArray);
        this.manualbillselectedRowdata = filteredArray;
      }
    }
    //console.log(this.manualbillselectedRowdata);
  }

  adhocbillselectedRowdata: any = [];
  adhocbillsdeselectedRowdata: any = [];
  adhocbillsonSelect(event: any) {
    //  console.log(event.selectedRows);
    var selectedval = event.selectedRows;
    var deselectedVal = event.deselectedRows;
    if (selectedval.length > 0) {
      selectedval.forEach((element: any) => {
        this.adhocbillselectedRowdata.push(element.dataItem);
        //console.log(' selected Values : ', this.adhocbillselectedRowdata);
      });
    }
    if (deselectedVal.length > 0) {
      deselectedVal.forEach((element: any) => {
        this.adhocbillsdeselectedRowdata.push(element.dataItem);
        /*  console.log(
           'deselectedRowdata Values : ',
           this.adhocbillsdeselectedRowdata
         ); */
      });

      if (this.adhocbillsdeselectedRowdata.length > 0) {
        const idsToRemove = new Set(
          this.adhocbillsdeselectedRowdata.map((item: { id: any }) => item.id)
        );

        const filteredArray = this.adhocbillselectedRowdata.filter(
          (item: { id: unknown }) => !idsToRemove.has(item.id)
        );
        //  console.log('', filteredArray);
        this.adhocbillselectedRowdata = filteredArray;
      }
    }
  }

  protected billsPageChange({ skip, take }: PageChangeEvent): void {
    //  console.log('>>>', skip, take);
    this.skip = skip;
    this.pageSize = take;
    this.billscurrentPage = Math.floor(skip / take) + 1;
    //  console.log('currentpage', Math.floor(skip / take) + 1);
    this.getBillsList();
    this.loadBillsGridTable();
  }

  protected manualconsumerPageChange({ skip, take }: PageChangeEvent): void {
    //  console.log('>>>', skip, take);
    this.skip = skip;
    this.manualpageSize = take;
    this.maulabillscurrentPage = Math.floor(skip / take) + 1;
    //   console.log('currentpage', Math.floor(skip / take) + 1);
    this.getMaunualList();
    this.loadManualBillsGridTable();
  }

  protected adhocPageChange({ skip, take }: PageChangeEvent): void {
    //   console.log('>>>', skip, take);
    this.skip = skip;
    this.adhocpageSize = take;
    this.adhocbillscurrentPage = Math.floor(skip / take) + 1;
    // console.log('currentpage', Math.floor(skip / take) + 1);
    this.getAdhoclist();
    this.loadAdhocBillsGridTable();
  }

  protected billsStateChange(state: DataStateChangeEvent): void {
    this.sort = state.sort || [];
    this.filter = state.filter || { logic: 'and', filters: [] };
    this.loadBillsGridTable();
  }

  protected manualbillStateChange(state: DataStateChangeEvent): void {
    this.sort = state.sort || [];
    this.filter = state.filter || { logic: 'and', filters: [] };
    this.loadManualBillsGridTable();
  }

  protected adhocbillStateChange(state: DataStateChangeEvent): void {
    this.sort = state.sort || [];
    this.filter = state.filter || { logic: 'and', filters: [] };
    this.loadAdhocBillsGridTable();
  }

  deleteUtilities() {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-primary',
        cancelButton: 'btn btn-outline-primary ms-2',
      },
      buttonsStyling: false,
    });

    swalWithBootstrapButtons
      .fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, cancel!',
        showCancelButton: true,
      })
      .then((result) => {
        if (result.value) {
          swalWithBootstrapButtons.fire(
            'Deleted!',
            'Your file has been deleted.',
            'success'
          );
        } else if (
          /* Read more about handling dismissals below */
          result.dismiss === Swal.DismissReason.cancel
        ) {
          swalWithBootstrapButtons.fire(
            'Cancelled',
            'Your imaginary file is safe :)',
            'error'
          );
        }
      });
  }

  public bilsonFilter(value: any): void {
    const inputValue = value;
    this.triggerSearchBills();
    // this.billsearchedValue = value;
    /*  this.store.dispatch(
      getBillslist({
        projectId: this.projectId,
        pageIndex: this.billscurrentPage,
        pageSize: this.pageSize,
        searchTerm: this.billsearchedValue,
        billType: 'bills',
        filter: this.billqueryString,
        orderBy: this.orderByQuery,
      })
    ); */
  }

  public onSearchConsumers(): void {
    this.triggerSearchBills();
    /*  if (this.billsearchedValue.length > 0) {
      

      this.store.dispatch(
        getBillslist({
          projectId: this.projectId,
          pageIndex: this.billscurrentPage,
          pageSize: this.pageSize,
          searchTerm: this.billsearchedValue,
          billType: 'bills',
          filter: this.billqueryString,
          orderBy: this.orderByQuery,
        })
      );
    } */
  }
  public manualbilsonFilter(value: any): void {
    const inputValue = value;
    this.triggerSearchmanual();
    //this.manualsarchedValue = value;
    /* this.store.dispatch(
      getManuallist({
        projectId: this.projectId,
        pageIndex: this.maulabillscurrentPage,
        pageSize: this.manualpageSize,
        searchTerm: this.manualsarchedValue,
        billType: 'manual',
      })
    ); */
  }

  public onSearchManualBills(): void {
    this.triggerSearchmanual();
    //  console.log(this.manualsarchedValue.length)
    /* if (this.manualsarchedValue.length > 0) {
      
      this.store.dispatch(
        getManuallist({
          projectId: this.projectId,
          pageIndex: this.maulabillscurrentPage,
          pageSize: this.manualpageSize,
          searchTerm: this.manualsarchedValue,
          billType: 'manual',
        })
      );
    } */
  }
  public onSearchAdhoclBills(): void {
    this.triggerSearchAdhoc()
    //  console.log(this.adhocSearchedValue.length)
    /* if (this.adhocSearchedValue.length > 0) {
      this.getAdhoclist();
      
    } */
  }

  public adhocbilsonFilter(value: any): void {
    //  console.log(this.adhocSearchedValue)
    const inputValue = value;
    this.triggerSearchAdhoc();
    // this.getAdhoclist();
    //this.adhocSearchedValue = value;
    /*  getAdhoclist({
       projectId: this.projectId,
       pageIndex: this.adhocbillscurrentPage,
       pageSize: this.adhocpageSize,
       searchTerm: this.adhocSearchedValue,
       billType: 'adhoc',
       filter: this.adhocqueryString,
       orderBy: this.orderByQuery,
     }); */
  }

  viewBilsdeatils(dataItem: any): void {
    let data = dataItem;
    if (this.stepper) {
      localStorage.setItem(
        'selectedTabIndex',
        this.stepper.selectedIndex.toString()
      );
    }
    this.router.navigate(['/bills/billsDetails'], { state: { bilss: data } });
  }

  releaseBills() {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-primary',
        cancelButton: 'btn btn-outline-primary ms-2',
      },
      buttonsStyling: false,
    });

    swalWithBootstrapButtons
      .fire({
        title: 'Are you sure?',
        text: 'You want to Release Bills ',
        icon: 'warning',
        confirmButtonText: 'Yes, Release Bills!',
        cancelButtonText: 'No, cancel!',
        showCancelButton: true,
      })
      .then((result) => {
        //  console.log(result.value);
        if (result.value) {
          this.loaderService.setLoading(true);
          let request = {
            ProjectId: this.projectId,
            UserId: this.userId,
          };
          this.billsService.releaseBills(request).subscribe({
            next: (response) => {
              if (response && response.statusCode === 201) {
                //      console.log(response);
                this.store.dispatch(
                  getBillslist({
                    projectId: this.projectId,
                    pageIndex: 1,
                    pageSize: 10,
                    searchTerm: '',
                    billType: 'bills',
                  })
                );
              }
            },
            error: (err) => {
              this.loaderService.setLoading(false);
            },
          });
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          this.loaderService.setLoading(false);
        }
      });
  }
  downloadBillsPaymentreceipt(data: any) {
    //event.stopPropagation();
    let temp = {
      // status: data.paymentStatus,
      paymentId: data.transactionId,
    };
    //downloadBillsPayment

    this.sharedService.downloadBillsPaymentrecceipt(temp).subscribe({
      next: (blob: Blob) => {
        //  const contentDisposition = blob.type === 'application/pdf' ? `attachment; filename="${}"` : null;
        // let filename = 'PaymentReceipt.pdf'; // Default filename
        const sanitizedConsumerName = data.consumerName.replace(/\s+/g, '_'); // Replace spaces with underscores
        const sanitizedUnit = data.residentialUnit.replace(/\s+/g, '_'); // In case of spaces
        const filename = `Receipt_${sanitizedConsumerName}_${sanitizedUnit}.pdf`;
        // If content disposition is available, extract filename
        /* s */
        if (blob) {
          this.loaderService.setLoading(false);
          //  console.log('Binary data received:', blob);
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = filename;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
        } else {
          this.loaderService.setLoading(false);
          console.error('Blob is null');
        }
      },
      error: (err) => {
        this.loaderService.setLoading(false);
        console.error('Error occurred:', err);
      },
    });
  }

  downloadbillsumary(data: any) {
    console.log(data);
    //event.stopPropagation();
    let temp = {
      id: data.billNo,
      status: data.paymentStatus,
      // paymentId: data.transactionId
    };
    //downloadBillsPayment

    this.sharedService.downloadBillsPayment(temp).subscribe({
      next: (blob: Blob) => {
        //  const contentDisposition = blob.type === 'application/pdf' ? `attachment; filename="${}"` : null;
        //let filename = 'Bill Summary.pdf'; // Default filename
        const sanitizedConsumerName = data.consumerName.replace(/\s+/g, '_'); // Replace spaces with underscores
        const sanitizedUnit = data.residentialUnit.replace(/\s+/g, '_'); // In case of spaces

        const filename = `Bill_${sanitizedConsumerName}_${sanitizedUnit}.pdf`;

        // If content disposition is available, extract filename
        /* s */
        if (blob) {
          this.loaderService.setLoading(false);
          console.log('Binary data received:', blob);
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = filename;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
        } else {
          this.loaderService.setLoading(false);
          console.error('Blob is null');
        }
      },
      error: (err) => {
        this.loaderService.setLoading(false);
        console.error('Error occurred:', err);
      },
    });
  }

  createBill(billType: string) {
    let sendData = {
      billType: billType,
      billgeneratetype: this.billGenType,
    };
    if (this.stepper) {
      localStorage.setItem(
        'selectedTabIndex',
        this.stepper.selectedIndex.toString()
      );
    }
    this.router.navigate(['bills/createBill'], {
      state: { billsData: sendData },
    });
  }
  /* viewManualdeatils(dataItem: any, ): void {
  
    let data = dataItem;
    data['billType'] = billType;
    this.router.navigate(['/bills/billsDetails'], { state: { bilss: data } })
  
  }
  
  viewadhocdeatils(dataItem: any, ): void {
    let data = dataItem;
    data.billType = billType;
    this.router.navigate(['/bills/billsDetails'], { state: { bilss: data } })
  
  } */

  onbillsSortChange(sort: SortDescriptor[]): void {
    this.bill.sort = sort;
    //  console.log(this.bill.sort);
    const orderByQuery = this.sharedService.createOrderByQuery(this.bill.sort);

    this.orderByQuery = orderByQuery;
    this.getBillsList();
    /* this.store.dispatch(
      getBillslist({
        projectId: this.projectId,
        pageIndex: this.billscurrentPage,
        pageSize: this.pageSize,
        searchTerm: this.billsearchedValue,
        billType: 'bills',
        filter: this.billqueryString,
        orderBy: this.orderByQuery,
      })
    ); */
  }


  public customAdhocFilterState: State = {
    skip: 0,
    take: 10,
    filter: {
      logic: 'and',
      filters: [],
    },
  };
  customAdhocDateFiltersQueryEq: any[] = [];
  customAdhocDateFiltersQueryNEQ: any[] = [];
  async onadhocFilterChange(filter: CompositeFilterDescriptor) {
    this.adhocbill.filter = filter;
    // console.log(this.adhocbill);
    this.skip = 0;
    let isFilter = filter.filters.length > 0 ? true : false;
    localStorage.setItem('filter', JSON.stringify(isFilter));
    this.sharedService.setFilter(filter);

    this.customAdhocFilterState = {
      skip: 0,
      take: 10,
      filter: {
        logic: 'and',
        filters: [],
      },
    };
    this.customAdhocFilterState = _.cloneDeep(this.adhocbill);
    var filterOperators = await this.sharedService.togetFilterOperators(
      this.adhocbill
    );
    // console.log("temp-------------->", filterOperators)
    const iscustomdates = filterOperators?.filter((filter: any) => {
      return filter.value instanceof Date;
    });

    let isEq: any;
    let isNeq: any;
    this.customAdhocDateFiltersQueryEq = [];
    this.customAdhocDateFiltersQueryNEQ = [];

    if (iscustomdates && iscustomdates.length > 0) {
      isEq = iscustomdates.filter((filter: any) => filter.operator === 'eq');
      isNeq = iscustomdates.filter((filter: any) => filter.operator === 'neq');

      if (isEq.length > 0) {
        this.customDateFiltersQueryEq =
          this.sharedService.customizeFilterQueryEQ(isEq);
        //   console.log("gasQueryString", this.customDateFiltersQueryEq)
      }
      if (isNeq?.length > 0) {
        isNeq.forEach((item: any) => {
          this.customAdhocDateFiltersQueryNEQ =
            this.sharedService.customizeFilterQueryNEQ(isNeq);
          //     console.log("gasQueryString", this.customDateFiltersQueryNEQ)
        });
      }
    } else {
      isNeq = undefined;
      isEq = undefined;
      this.customAdhocDateFiltersQueryEq = [];
      this.customAdhocDateFiltersQueryNEQ = [];
    }
    if (
      this.customAdhocDateFiltersQueryEq.length > 0 ||
      this.customDateFiltersQueryNEQ.length > 0
    ) {
      let customFilterQueryString =
        await this.sharedService.newmodifyFilterJson(
          this.customAdhocFilterState,
          this.customAdhocDateFiltersQueryEq,
          this.customAdhocDateFiltersQueryNEQ
        );
      this.adhocqueryString = this.sharedService.dateFiltercreateQuery(
        customFilterQueryString
      );
    } else {
      this.adhocqueryString = this.sharedService.createQuery(
        this.customAdhocFilterState
      );
    }
    const queryString = this.sharedService.createQuery(this.adhocbill);
    this.getAdhoclist();
    // this.adhocqueryString = this.sharedService.createQuery(this.adhocbill);
    /* this.store.dispatch(
      getAdhoclist({
        projectId: this.projectId,
        pageIndex: 1,
        pageSize: this.adhocpageSize,
        searchTerm: this.adhocSearchedValue,
        billType: 'adhoc',
        filter: this.adhocqueryString,
        orderBy: this.orderByQuery,
      })
    ); */
    //  console.log(queryString);
  }

  onAdhocSortChange(sort: SortDescriptor[]): void {
    this.adhocbill.sort = sort;
    //   console.log(this.adhocbill.sort);
    const orderByQuery = this.sharedService.createOrderByQuery(
      this.adhocbill.sort
    );

    this.orderByAdhocQuery = orderByQuery;
    this.getAdhoclist();
    /* this.store.dispatch(
      getAdhoclist({
        projectId: this.projectId,
        pageIndex: this.adhocbillscurrentPage,
        pageSize: this.adhocpageSize,
        searchTerm: this.adhocSearchedValue,
        billType: 'adhoc',
        filter: this.adhocqueryString,
        orderBy: this.orderByQuery,
      })
    ); */
  }

  public customFilterState: State = {
    skip: 0,
    take: 10,
    filter: {
      logic: 'and',
      filters: [],
    },
  };
  customDateFiltersQueryEq: any[] = [];
  customDateFiltersQueryNEQ: any[] = [];
  async onbillsFilterChange(filter: CompositeFilterDescriptor) {
    this.bill.filter = filter;
    this.skip = 0;
    //  console.log("bilst filter", this.bill);
    let isFilter = filter.filters.length > 0 ? true : false;
    localStorage.setItem('filter', JSON.stringify(isFilter));
    this.sharedService.setFilter(filter);

    this.customFilterState = {
      skip: 0,
      take: 10,
      filter: {
        logic: 'and',
        filters: [],
      },
    };
    this.customFilterState = _.cloneDeep(this.bill);
    var filterOperators = await this.sharedService.togetFilterOperators(
      this.bill
    );
    // console.log("temp-------------->", filterOperators)
    const iscustomdates = filterOperators?.filter((filter: any) => {
      return filter.value instanceof Date;
    });

    let isEq: any;
    let isNeq: any;
    this.customDateFiltersQueryEq = [];
    this.customDateFiltersQueryNEQ = [];

    if (iscustomdates && iscustomdates.length > 0) {
      isEq = iscustomdates.filter((filter: any) => filter.operator === 'eq');
      isNeq = iscustomdates.filter((filter: any) => filter.operator === 'neq');

      if (isEq.length > 0) {
        this.customDateFiltersQueryEq =
          this.sharedService.customizeFilterQueryEQ(isEq);
        //   console.log("gasQueryString", this.customDateFiltersQueryEq)
      }
      if (isNeq?.length > 0) {
        isNeq.forEach((item: any) => {
          this.customDateFiltersQueryNEQ =
            this.sharedService.customizeFilterQueryNEQ(isNeq);
          //    console.log("gasQueryString", this.customDateFiltersQueryNEQ)
        });
      }
    } else {
      isNeq = undefined;
      isEq = undefined;
      this.customDateFiltersQueryEq = [];
      this.customDateFiltersQueryNEQ = [];
    }
    if (
      this.customDateFiltersQueryEq.length > 0 ||
      this.customDateFiltersQueryNEQ.length > 0
    ) {
      let customFilterQueryString =
        await this.sharedService.newmodifyFilterJson(
          this.customFilterState,
          this.customDateFiltersQueryEq,
          this.customDateFiltersQueryNEQ
        );
      this.billqueryString = this.sharedService.dateFiltercreateQuery(
        customFilterQueryString
      );
    } else {
      this.billqueryString = this.sharedService.createQuery(
        this.customFilterState
      );
    }

    //  console.log(filter)
    const queryString = this.sharedService.createQuery(this.bill);
    this.getBillsList()
    /*  this.billqueryString = this.sharedService.createQuery(this.bill); */
    /* this.store.dispatch(
      getBillslist({
        projectId: this.projectId,
        pageIndex: 1,
        pageSize: this.pageSize,
        searchTerm: this.billsearchedValue,
        billType: 'bills',
        filter: this.billqueryString,
        orderBy: this.orderByQuery,
      })
    ); */
    //   console.log(queryString);
  }

  public customManualFilterState: State = {
    skip: 0,
    take: 10,
    filter: {
      logic: 'and',
      filters: [],
    },
  };

  customManualDateFiltersQueryEq: any[] = [];
  customManualDateFiltersQueryNEQ: any[] = [];
  async onmanualFilterChange(filter: CompositeFilterDescriptor) {
    this.manualbill.filter = filter;
    this.skip = 0;
    //  console.log(this.manualbill);
    let isFilter = filter.filters.length > 0 ? true : false;
    localStorage.setItem('filter', JSON.stringify(isFilter));
    this.sharedService.setFilter(filter);

    this.customManualFilterState = {
      skip: 0,
      take: 10,
      filter: {
        logic: 'and',
        filters: [],
      },
    };
    this.customManualFilterState = _.cloneDeep(this.manualbill);
    var filterOperators = await this.sharedService.togetFilterOperators(
      this.manualbill
    );
    // console.log("temp-------------->", filterOperators)
    const iscustomdates = filterOperators?.filter((filter: any) => {
      return filter.value instanceof Date;
    });

    let isEq: any;
    let isNeq: any;
    this.customManualDateFiltersQueryEq = [];
    this.customManualDateFiltersQueryNEQ = [];

    if (iscustomdates && iscustomdates.length > 0) {
      isEq = iscustomdates.filter((filter: any) => filter.operator === 'eq');
      isNeq = iscustomdates.filter((filter: any) => filter.operator === 'neq');

      if (isEq.length > 0) {
        this.customManualDateFiltersQueryEq =
          this.sharedService.customizeFilterQueryEQ(isEq);
        //    console.log("gasQueryString", this.customDateFiltersQueryEq)
      }
      if (isNeq?.length > 0) {
        isNeq.forEach((item: any) => {
          this.customManualDateFiltersQueryNEQ =
            this.sharedService.customizeFilterQueryNEQ(isNeq);
          //     console.log("gasQueryString", this.customDateFiltersQueryNEQ)
        });
      }
    } else {
      isNeq = undefined;
      isEq = undefined;
      this.customManualDateFiltersQueryEq = [];
      this.customManualDateFiltersQueryNEQ = [];
    }
    if (
      this.customManualDateFiltersQueryEq.length > 0 ||
      this.customManualDateFiltersQueryNEQ.length > 0
    ) {
      let customFilterQueryString =
        await this.sharedService.newmodifyFilterJson(
          this.customManualFilterState,
          this.customManualDateFiltersQueryEq,
          this.customManualDateFiltersQueryNEQ
        );
      this.manualqueryString = this.sharedService.dateFiltercreateQuery(
        customFilterQueryString
      );
    } else {
      this.manualqueryString = this.sharedService.createQuery(
        this.customManualFilterState
      );
    }

    const queryString = this.sharedService.createQuery(this.manualbill);
    this.getMaunualList();
    //  this.manualqueryString = this.sharedService.createQuery(this.manualbill);
    /*  this.store.dispatch(
       getManuallist({
         projectId: this.projectId,
         pageIndex: 1,
         pageSize: this.manualpageSize,
         searchTerm: this.manualsarchedValue,
         billType: 'manual',
         filter: this.manualqueryString,
         orderBy: this.orderByQuery,
       })
     ); */
    // console.log(queryString);
  }

  onManualSortChange(sort: SortDescriptor[]): void {
    this.manualbill.sort = sort;
    //  console.log(this.manualbill.sort);
    const orderByQuery = this.sharedService.createOrderByQuery(
      this.manualbill.sort
    );

    this.ordeyrByManualQuery = orderByQuery;
    this.getMaunualList();
    /*  this.store.dispatch(
       getManuallist({
         projectId: this.projectId,
         pageIndex: this.maulabillscurrentPage,
         pageSize: this.manualpageSize,
         searchTerm: this.manualsarchedValue,
         billType: 'manual',
         filter: this.manualqueryString,
         orderBy: this.orderByQuery,
       })
     ); */
  }
}
